import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["inline", "title", "titleWeight", "children", "size", "fullWidth", "scrollable"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import styles from './ChipsGroup.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонента для объединения нескольких ChipButton горизонтальную группу
 */
export const ChipsGroup = _ref => {
  let {
      inline,
      title,
      titleWeight = 'bold',
      children,
      size = 'M',
      fullWidth,
      scrollable
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: clsx(styles['chips-group'], {
      [styles['chips-group--inline']]: inline,
      [styles['chips-group--fullWidth']]: fullWidth
    })
  }, restProps), {}, {
    children: [title && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['title'], {
        [styles['title--small']]: size === 'XS',
        [styles['title--medium']]: size === 'M',
        [styles['title--bold']]: titleWeight === 'bold'
      }),
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      className: clsx(styles['content'], {
        [styles['content--wrap']]: !fullWidth && !scrollable,
        [styles['content--scrollable']]: !fullWidth && scrollable
      }),
      children: React.Children.map(children, (child, i) => child && /*#__PURE__*/_jsx("li", {
        className: styles['item'],
        children: child
      }, i))
    })]
  }));
};